import { User } from 'types/user';
import { RoleType } from 'types/role-type';

export const initialState: UserProfileState = {
  user: {
    id: '',
    username: '',
    firstName: '',
    lastName: '',
    email: '',
    roleType: RoleType.Unknown
  } as User,
  isProcessing: false,
  isLoadingProfileInfo: false,
  errorMessage: ''
};

export interface UserProfileState {
  user: User;
  isProcessing: boolean;
  isLoadingProfileInfo: boolean;
  errorMessage: string;
}


// WEBPACK FOOTER //
// ./src/pages/user-profile/state.ts